module.exports = __webpack_public_path__ + "static/img/jiaying-icon.871c8e90.png";